"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowAction = void 0;
class WorkflowAction {
    /* CONSTRUCTOR */
    constructor(o = {}) {
        this.workflowActionType = o.workflowActionType || '';
        this.workflowActionConfig = Object.assign({}, (o.workflowActionConfig || {}));
    }
}
exports.WorkflowAction = WorkflowAction;
exports.default = WorkflowAction;
